import { useRef, useEffect } from "react";
import NotifySearchArea from "./NotifySearchArea";
import FloatingButton from "@/FloatingButton";
import { IconWrite } from "@/Icon/Wirite";
import { useRouter } from "@tanstack/react-router";
import useNotifySaved from "^/business/notify/useNotifySaved";
import NotifyHeader from "./HeaderComponent";
import ContentComponent from "./ContentComponent";

export interface NotifyDataTypes {
  noticeSeq: number;
  notiRecvSeq: number;
  profileImgUrl: string | null;
  notiTitle: string;
  notiContents: string;
  cdNotiType: string;
  readYn: string;
  dtSend: string;
  recipientName: string;
  petName: string;
  petWeight: number;
  businessName: string;
  fileUrls: string[];
  businessNewReplyYn?: string; // 새로운 댓글 여부 (Y/N)
}

const NotifySaved = () => {
  const { history } = useRouter();
  const loadMoreRef = useRef<HTMLDivElement>(null);
  const {
    savedData,
    hasMore,
    onLoad,
    handleSearch,
    filterType,
    setFilterType,
    dropdownOpen,
    setDropdownOpen,
    selectedType,
    setSelectedType,
    searchText,
    setSearchText,
    isLoading,
  } = useNotifySaved();

  // 스크롤 하단 도달 시 추가 로드 (10개씩)
  useEffect(() => {
    if (!hasMore || isLoading) return;
    const el = loadMoreRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) onLoad();
      },
      { root: null, rootMargin: "100px", threshold: 0 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [hasMore, isLoading, onLoad]);

  const wiriteButtonClick = () => {
    history.push("/business/layout/notify-send");
  };
  const handleRead = (key: string) => {
    history.push(`/business/layout/notify-saved-notify?noticeSeq=${key}`);
  };

  return (
    <div className="flex-auto p-2 mt-1">
      <NotifySearchArea
        useFilter={false}
        handleSearch={handleSearch}
        filterType={filterType}
        setFilterType={
          setFilterType as React.Dispatch<React.SetStateAction<string>>
        }
        dropdownOpen={dropdownOpen}
        setDropdownOpen={setDropdownOpen}
        selectedType={selectedType}
        setSelectedType={
          setSelectedType as React.Dispatch<React.SetStateAction<string>>
        }
        searchText={searchText}
        setSearchText={setSearchText}
      />
      <div className="grid grid-cols-1 gap-2 px-1 pt-2 pb-1 mb-1">
        {/* <IconNotice />
          <IconNotify /> */}
        {savedData?.map((item: NotifyDataTypes, i: number) => {
          return (
            <div
              className="mb-2"
              key={i}
              onClick={() => handleRead(item.noticeSeq.toString())}
            >
              <NotifyHeader data={item} isUse={false} />
              <ContentComponent data={item} />
            </div>
          );
        })}
      </div>
      {hasMore && <div ref={loadMoreRef} className="h-4" aria-hidden />}
      {isLoading && Array.isArray(savedData) && savedData.length > 0 && (
        <div className="flex justify-center py-2 text-gray-500 text-sm">
          불러오는 중...
        </div>
      )}
      <FloatingButton onClick={() => wiriteButtonClick()}>
        <IconWrite />
      </FloatingButton>
    </div>
  );
};

export default NotifySaved;

// function DiaryHeader({ data }: any) {
//   return (
//     <div className="flex gap-2 items-center mb-2">
//       <img
//         src={data.petImg}
//         alt="프로필"
//         className="object-cover w-10 h-10 rounded-full"
//       />
//       <div className="flex-1">
//         <div className="flex gap-2 items-center">
//           <p className="font-semibold text-m">{data.petName}</p>
//           <p className="text-[#999999] text-[14px]">{data.petWeight}</p>
//         </div>
//         <div className="flex justify-between items-center w-full">
//           <div className="text-gray-400 text-s">
//             <p className="text-[#999999] text-[12px]">{data.date}</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
